import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  function validateFpItemForm() {
    // either it's an existing model and we don't care about these
    // or it's a new model and svg/png images have been generated
    const imagePresent = !$('#svg').length || ($('#svg').val().length && $('#png').val().length);

    const name = $('#fp_item_name').val().length > 0;
    const x = $('#fp_item_dimensions_x').val().length > 0;
    const y = $('#fp_item_dimensions_y').val().length > 0;
    const z = $('#fp_item_dimensions_z').val().length > 0;

    $('[data-button-save-fp-item]').prop(
      'disabled',
      $('body').is('#admin-fp-items-new') && !(imagePresent && name && x && y && z)
    );
  }

  $(document).on('click', '[data-fp-item-previews]', (e) => {
    const file = $('input[name="fp_item[uncompressed_glb_file]"]')[0].files[0];
    const dimensions = {
      x: $('input[name="fp_item[dimensions][x]"]').val(),
      y: $('input[name="fp_item[dimensions][y]"]').val(),
      z: $('input[name="fp_item[dimensions][z]"]').val(),
    };

    if (dimensions.x === '' || dimensions.y === '' || dimensions.z === '') {
      alert('Dimensions are required for preview generation.');
      return;
    }

    if (file === undefined) {
      return;
    }

    const $btn = $(e.target);
    $btn.prop('disabled', true).text('Generating Previews...');

    const emptyGif = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
    $('.admin-fp-items-svg').attr('src', emptyGif);
    $('.admin-fp-items-png').attr('src', emptyGif);
    $('#fp_item_name').focus();

    const generatePreviewRequest = ({ dimensions, file, format, successCallback }) => {
      const form = document.querySelector('.new-fp-item-form');
      const url = `${form.dataset.glbToSvgUrl || ''}/generate_thumb`;
      const { x, y, z } = dimensions;
      const body = new FormData();

      body.append('glb_file', file);
      body.append('dimensions', `${x},${y},${z}`);
      body.append('format', format);

      fetch(url, { method: 'post', body })
        .then((response) => {
          if (response.ok) {
            return response.blob();
          } else {
            throw new Error();
          }
        })
        .then((blob) => successCallback(blob))
        .catch(() => alert('Something went wrong.'));
    };

    const generatePng = ({ file, dimensions }) => {
      generatePreviewRequest({
        dimensions,
        file,
        format: 'png',
        successCallback: (blob) => {
          const reader = new FileReader();
          reader.onload = function () {
            const base64 = reader.result;

            $('#png').val(base64);
            $('.admin-fp-items-png').attr('src', base64);
          };
          reader.readAsDataURL(blob);

          $('[data-fp-item-previews]').prop('disabled', false).text('Generate Previews');

          validateFpItemForm();
        },
      });
    };

    generatePreviewRequest({
      dimensions,
      file,
      format: 'svg',
      successCallback: (blob) => {
        blob.text().then((svgText) => {
          const svgSrc = `data:image/svg+xml,${encodeURIComponent(svgText)}`;

          $('[name="fp_item[svg]"]').val(svgText);
          $('.admin-fp-items-svg').attr('src', svgSrc);
        });

        $('[data-fp-item-previews]').prop('disabled', false).text('Generate Previews');

        generatePng({ file, dimensions });
      },
    });

    validateFpItemForm();

    return false;
  });

  $(document).on(
    'change, keyup',
    '#fp_item_name, #fp_item_dimensions_x, #fp_item_dimensions_y, #fp_item_dimensions_z',
    () => {
      validateFpItemForm();
    }
  );

  // Render the name of the GLB file selected in the input.
  document.addEventListener('change', (e) => {
    const target = e.target;

    if (!target.matches('[data-fp-item--glb-file-input]')) {
      return;
    }

    const label = target.closest('[data-fp-item--glb-file-label]');
    const defaultText = label.dataset.defaultLabel;
    const fileName = target.files[0]?.name;

    let updated = false;
    label.childNodes.forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        node.textContent = !updated ? fileName || defaultText : '';
        updated = true;
      }
    });
  });

  $(function () {
    if ($('body').is('#admin-fp-items-edit')) {
      validateFpItemForm();
    }
  });
});
